import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { bbAnalytics } from '../helpers/analytics/setup/analytics.service.handler';

const PageViewTracker = ({ children }) => {
  const page = useSelector((app) => app.page);

  useEffect(() => {
    if (page !== '') {
      bbAnalytics.triggerPageView(page.name);
    }
  }, [page]);
  return children;
};

export default PageViewTracker;
